<template>
  <div>
    <base-header type="gradient-rmn" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <devices-table-basic class="mb-3" v-if="!getUser.isAdmin"></devices-table-basic>
          <analysis-table></analysis-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnalysisTable from "./Tables/AnalysisTable";
import DevicesTableBasic from "./Tables/DevicesTableBasic";
import { mapGetters } from 'vuex'

export default {
  name: "dashboard",
  components: {
    AnalysisTable,
    DevicesTableBasic
  },
  computed: {
      ...mapGetters(['getUser'])
  }
};
</script>
<style></style>
